import { render, staticRenderFns } from "./r-worker-team-dialog.vue?vue&type=template&id=3b7de94a&scoped=true"
import script from "./r-worker-team-dialog.vue?vue&type=script&lang=js"
export * from "./r-worker-team-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-worker-team-dialog.vue?vue&type=style&index=0&id=3b7de94a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7de94a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b7de94a')) {
      api.createRecord('3b7de94a', component.options)
    } else {
      api.reload('3b7de94a', component.options)
    }
    module.hot.accept("./r-worker-team-dialog.vue?vue&type=template&id=3b7de94a&scoped=true", function () {
      api.rerender('3b7de94a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker/r-worker-team-dialog.vue"
export default component.exports